import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import ThemeToggle from '../ThemeToggle';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: 1,
        borderColor: 'divider'
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <Typography variant="body2" color="text.secondary">
            © 2025 SwimTeam Pro
          </Typography>
          <ThemeToggle />
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;